import * as React from "react";

import "./wallet-layout.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Load}           from "@Common/react/load";
import {chain}          from "@Common/utils/fs";

import {AccountTabsLayout} from "../../common/account-tabs-layout/account-tabs-layout";

export const WalletLayout = ({activeTab, next}) => cs(
    consumeContext("accountMenu"),
    consumeContext("apis"),
    ["vouchers", ({apis}, next) => Load({
        fetch: () => apis.next.vouchers.getVoucherHistory(),
        next,
    })],
    ({accountMenu, vouchers}, next) => AccountTabsLayout({
        activeMenu: "wallet",
        activeTab,
        config: chain(
            accountMenu?.["walletMenu"]?.subMenu ?? items,
            (_) => activeTab === "vouchers" || vouchers && Object.keys(vouchers).length ? _ : (
                _.filter((item) => item.name !== "vouchers")
            ),
        ),
        next,
    }),
    ({vouchers}) => (
        <div className="wallet-layout-37e">
            {next({vouchers})}
        </div>
    ),
);

const items = [
    {
        linkLabel: "Credit Cards",
        name : "credit-cards",
        link: "/account/wallet/credit-cards",
    },
    {
        linkLabel: "Vouchers",
        name : "vouchers",
        link: "/account/wallet/vouchers",
    },
    {
        linkLabel: "Ad Budget",
        name : "ad-budget",
        link: "/account/wallet/ad-budget",
    },
    {
        linkLabel: "Store Credit",
        name : "store-credit",
        link: "/account/wallet/store-credit",
    },
];
